import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/tax'
export default {
	/**
	 * @description 查看列表
	 * @author Lzp
	 * @date 2021/9/29
	 * @param {*} data
	 * @returns
	 */
	getManageTaxList(data) {
		return request.get(`${BASE_URL}/index`, data)
	},

	postManageTaxInfo(data) {
		return request.post(`${BASE_URL}/create`,data)
	},
    
    getAreaCodeList(data) {
		return request.get(`${BASE_URL}/area`,data)
	}
}
